import { Injectable } from '@angular/core';
import { CVApiService } from './cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class YouTubeInfoService {
    constructor(
        private cvApiService: CVApiService
    ) { }

    /**
     * Retrieves information for the specified YouTube video(s), such as video title, duration, channel name, etc.
     * @param videoIds One or more 11-character YouTube video ID's. Can be either a single string or an array of string(s).
     */
    public async getYouTubeInformation(videoIds: string | string[]) {
        let idArray = [];
        if (typeof videoIds == `string`)
            idArray = [videoIds];
        else
            idArray = videoIds;

        try {
            let response = await this.cvApiService.post<any>(`/api/v1/youTubeInfo`, idArray);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load YouTube video information.`);
        }
    }
}
